import React, { useEffect, useState } from 'react'
import { Button, Form, message, Modal } from 'antd'
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc'
import arrayMove from 'array-move'
import {
  DragHandleWrapper,
  InstructionNote,
  ListWrapper,
  SortItem,
  SortModalFooter,
  SortModalGlobalStyle,
  SortModalWrapper,
} from './SortDepartmentModalStyled'
import { HolderOutlined, InfoCircleOutlined } from '@ant-design/icons'
import departmentStore from '../../../stores/departmentStore'

const SortDepartmentModal = sortDepartmentModalProps => {
  const {
    isVisibleSortDepartmentModal,
    handleCancelSortDepartmentModal,
    departmentList,
    onRefreshListDepartment,
  } = sortDepartmentModalProps

  const [isLoading, setIsLoading] = useState(false)
  const [items, setItems] = useState(departmentList)

  useEffect(() => {
    if (isVisibleSortDepartmentModal) {
      setItems(departmentList)
    }
  }, [isVisibleSortDepartmentModal])

  const DragHandle = sortableHandle(() => (
    <DragHandleWrapper>
      <HolderOutlined />
    </DragHandleWrapper>
  ))

  const SortableItem = sortableElement(({ value }) => (
    <SortItem>
      <DragHandle />
      <span>{value}</span>
    </SortItem>
  ))

  const SortableContainer = sortableContainer(({ children }) => {
    return <ListWrapper>{children}</ListWrapper>
  })

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setItems(arrayMove(items, oldIndex, newIndex))
  }

  const save = async () => {
    try {
      setIsLoading(true)
      await departmentStore.sort(items.map(item => item.code))

      onRefreshListDepartment()

      message.success('Sắp xếp thứ tự phòng ban thành công')

      handleCancelSortDepartmentModal()
    } catch (e) {
      console.log(e)
      message.error(e.vi || 'Có sự cố xảy ra')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      className="sort-department-modal"
      title={`Sắp xếp thứ tự hiển thị`}
      footer={null}
      closable={true}
      visible={isVisibleSortDepartmentModal}
      onCancel={handleCancelSortDepartmentModal}>
      <SortModalGlobalStyle />
      <SortModalWrapper>
        <InstructionNote>
          <InfoCircleOutlined />
          <span>Kéo giữ biểu tượng để thay đổi thứ tự hiển thị phòng ban</span>
        </InstructionNote>
        <Form layout={'vertical'}>
          <Form.Item style={{ marginBottom: 0 }}>
            <SortableContainer onSortEnd={onSortEnd} useDragHandle>
              {items.map((value, index) => (
                <SortableItem key={value.code} index={index} value={value.name} />
              ))}
            </SortableContainer>
          </Form.Item>

          <SortModalFooter>
            <Button
              className="btn-cancel"
              htmlType="button"
              onClick={handleCancelSortDepartmentModal}>
              Hủy
            </Button>
            <Button
              className="btn-submit"
              loading={isLoading}
              onClick={save}
              type={'primary'}>
              Cập nhật
            </Button>
          </SortModalFooter>
        </Form>
      </SortModalWrapper>
    </Modal>
  )
}

SortDepartmentModal.propTypes = {}

export default SortDepartmentModal
